{
  "version": 1,
  "asset_id": "bd639379-35c2-475b-a764-c44908ad3e0d",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/bd639379-35c2-475b-a764-c44908ad3e0d/dilated-pouch-contrast-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/bd639379-35c2-475b-a764-c44908ad3e0d/dilated-pouch-contrast-800.webp",
  "original_filename": "dilated-pouch-contrast-800.webp",
  "size": 29128,
  "content_type": "image/webp",
  "created_at": "2026-09-20T23:09:06Z"
}
